export default __webpack_public_path__ + "static/media/haikei.87734d0e.svg";